export default "__VITE_ASSET__3Je$HT4h__"